/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_HintInputs */

const cs_settings_profile_2fa_hint = /** @type {(inputs: Settings_Profile_2fa_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chraňte účet autentikační aplikací (TOTP).`)
};

const en_settings_profile_2fa_hint = /** @type {(inputs: Settings_Profile_2fa_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protect your account with an authenticator app (TOTP).`)
};

/**
* | output |
* | --- |
* | "Protect your account with an authenticator app (TOTP)." |
*
* @param {Settings_Profile_2fa_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_hint = /** @type {((inputs?: Settings_Profile_2fa_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_hint(inputs)
	return cs_settings_profile_2fa_hint(inputs)
});